<template>
    <div class="" style="margin-left: 75px">
        <d-site
            v-model  = "dialog"
            :site-id = "siteId"
            @saved   = "onSaved"
        />

        <c-app-bar
            title          = "ANLAGEN"
            :categories    = "['site']"
            :enable-search = "false"
        >
            <template slot="search">
                <m-site-search
                    class   = "ml-2"
                    @search = "onSearch"
                />
                <v-spacer />
            </template>
        </c-app-bar>

        <c-customer-index
            :minimize      = "false"
            :enable-search = "true"
            :filter-height = "225"
            @changed       = "onCustomer"
            style          = "padding-right: 75px;"
        >
            <template v-slot:detail="{  }">
                <m-site-table
                    :customer = "customerId"
                    :data     = "data"
                    @selected = "onSite"
                    ref       = "table"
                />
            </template>
        </c-customer-index>
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import CCustomerIndex from "@/modules/msd/company/customer/components/controlls/CCustomerIndex";
import MSiteTable     from "@/modules/msd/unit/components/main/MSiteTable";
import DSite          from "@/modules/msd/unit/components/dialog/DSite";
import CAppBar        from "@/modules/core/components/app/CAppBar";
import MSiteSearch    from "@/modules/msd/unit/components/main/MSiteSearch";

export default {
    name: "MSite",
    components: {
        MSiteSearch,
        CAppBar,
        DSite,
        MSiteTable,
        CCustomerIndex,
    },

    data: () => ({
        dialog: false,
        siteId: null,
        customerId: null,
        data : null,
        timeoutHandle: null,
        initialized: false,
    }),

    mounted() {
        Core.init.load(this.$store, false).then(() => {
            this.initialized = true;
            this.openRouteSite();
        })
    },

    watch: {
        // /sites/{siteId} opens the site, going back to /sites closes it
        "$route.params.siteId" () {
            this.openRouteSite();
        },

        dialog (open) {
            if (!open && this.$route.params.siteId) {
                this.$router.push({ name: "sites" }).catch(() => {});
            }
        }
    },

    methods: {
        onCustomer (customer) {
            if (!customer && customer !== 0) {
                this.customerId = null;
                return;
            }

            this.customerId = customer.id;
        },

        onSearch (options) {
            this.data = options;
        },

        onSite (site) {
            this.$router.push({ name: "site", params: { siteId: String(site.id) } }).catch(() => {});
        },

        openRouteSite () {
            if (!this.initialized) {
                return;
            }

            const id = this.$route.params.siteId;
            if (id) {
                this.siteId = /^\d+$/.test(id) ? Number(id) : id;
                this.dialog = true;
            } else {
                this.dialog = false;
            }
        },

        onSaved(site) {
            this.$refs.table.refresh(site);
        }
    }
}

</script>

<style scoped>

</style>